import React from 'react';
import NavBar from './NavBar';  // Import the NavBar component


function Home() {
  return (
    <div>
         <NavBar />
      <h1>Welcome to the Home Page</h1>
    </div>
  );
}

export default Home;
